module.exports = __webpack_public_path__ + "static/icons/icon-heart-bfbfb8ba78f054c8f381bdcdd4863513.svg";